export default function GestionCarteraBulkPanel({
  asesores = [],
  asesorDestinoId,
  selectedCount = 0,
  maxSelection = 500,
  submitting = false,
  errors = {},
  onDestinoChange,
  onSubmit,
  onClear,
}) {
  const disabled = submitting || selectedCount === 0 || !asesorDestinoId;
  const getErrorMessage = (error) => {
    if (!error) return '';
    return Array.isArray(error) ? error[0] : error;
  };

  return (
    <section className="rounded-3xl border border-slate-200 bg-white p-5 shadow-sm">
      <div className="space-y-4">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.24em] text-red-600">Reasignación masiva</p>
          <h2 className="mt-2 text-lg font-semibold text-slate-900">
            {selectedCount} crédito{selectedCount === 1 ? '' : 's'} seleccionado{selectedCount === 1 ? '' : 's'}
          </h2>
          <p className="mt-1 text-sm text-slate-600">
            Selecciona asesor destino y confirma transferencia de cartera activa.
          </p>
        </div>

        <div className="grid w-full grid-cols-1 items-start gap-3 lg:grid-cols-[minmax(220px,320px)_10rem_10rem]">
          <div className="min-w-0">
            <label htmlFor="id_asesor_destino" className="mb-2 block text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
              ASESOR DESTINO
            </label>
            <select
              id="id_asesor_destino"
              value={asesorDestinoId}
              onChange={(event) => onDestinoChange(event.target.value)}
              disabled={submitting || selectedCount === 0}
              className={[
                'w-full rounded-2xl border bg-white px-4 py-3 text-sm text-slate-900 shadow-sm transition',
                errors.id_asesor_destino
                  ? 'border-red-400 ring-2 ring-red-200'
                  : 'border-slate-200 focus:border-red-300 focus:ring-2 focus:ring-red-200',
                selectedCount === 0 ? 'cursor-not-allowed opacity-60' : '',
              ].join(' ')}
              aria-invalid={Boolean(errors.id_asesor_destino)}
            >
              <option value="">Seleccionar asesor</option>
              {asesores.map((asesor) => (
                <option key={asesor.id} value={asesor.id}>
                  {asesor.nombre}
                </option>
              ))}
            </select>
            <div className="h-5">
              {!!errors.id_asesor_destino ? (
                <p className="mt-1 text-xs text-red-600">{getErrorMessage(errors.id_asesor_destino)}</p>
              ) : null}
            </div>
          </div>
          <button
            type="button"
            onClick={onSubmit}
            disabled={disabled}
            className="h-12 w-full rounded-full bg-red-600 px-5 text-sm font-semibold text-white shadow-sm transition hover:bg-red-700 disabled:cursor-not-allowed disabled:bg-slate-300 lg:mt-7"
          >
            {submitting ? 'Reasignando...' : 'Reasignar'}
          </button>

          <button
            type="button"
            onClick={onClear}
            disabled={submitting || selectedCount === 0}
            className="h-12 w-full rounded-full border border-slate-200 bg-white px-5 text-sm font-semibold text-slate-700 shadow-sm transition hover:border-slate-300 hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-60 lg:mt-7"
          >
            Limpiar
          </button>
        </div>
      </div>

      {selectedCount >= maxSelection ? (
        <div className="mt-3 rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800">
          Límite alcanzado: backend permite hasta {maxSelection} créditos por operación.
        </div>
      ) : null}

      {!!errors.prestamos_ids ? (
        <div className="mt-3 rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
          {getErrorMessage(errors.prestamos_ids)}
        </div>
      ) : null}
    </section>
  );
}